import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';
import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { Router } from '@angular/router';
import { DataHelper } from '@helpers/data.helper';
import { MatDialog } from '@angular/material/dialog';
import { DepositFrameDialog } from '@components/deposit-frame-dialog';
import { environment } from '@environments/environment';
import { WithdrawPaypalB3000Component } from '@sharedTemplates/withdrawPaypal/b3000/withdraw-paypal-b3000.component';
import { WithdrawBankB3000Component } from '@sharedTemplates/withdrawBank/b3000/withdraw-bank-b3000.component';

@Component({
  selector: 'withdraw-b3000-component',
  templateUrl: './withdraw-b3000.component.html',
})
export class WithdrawB3000Component implements OnInit {
  //bet3000
  amount = 0;
  alertMessage = false;
  alertMessageDesc = '';
  @Input() isOpen;
  bookingsList = [];
  selectedYear;
  selectedMonth;
  //bet300
  yourIDControl: string;
  addressControl: string;
  creditCardControl: string;
  otherControl: string;
  PEP: string;
  WithdrawpaymentType: any;

  constructor(
    private _changeDetection: ChangeDetectorRef,
    private _FormBuilder: UntypedFormBuilder,
    private _ApiService: ApiService,
    private _UiHelper: UiHelper,
    public _UserHelper: UserHelper,
    private _LocalizationService: LocalizationService,
    private _router: Router,
    private _DataHelper: DataHelper,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    const today = new Date();
    const defaultYear = today.getFullYear();
    const defaultMonth = today.getMonth();
    this.selectedYear = defaultYear;
    this.selectedMonth = defaultMonth;
  }

  ngAfterViewInit() {
    if (this._UiHelper.rightMenu) {
      this._UiHelper.setRightMenu();
    }
    this._UiHelper.setNavbarTitle('Withdraw', true);
    this.getBookings();
    this.getInsicStatus();
    this._UserHelper.withdrawListListener.emit('init');
  }

  showDetail(e) {
    ////console.log(e);
    if (e == 'coinbase') {
      this._router.navigate(['/withdrawcoinbase']);
    } else if (e == 'banktransfer') {
      this._router.navigate(['/withdrawbanks']);
    } else if (e == 'muchbetter') {
      this._router.navigate(['/withdrawmuchbetter']);
    } else if (e == 'paypal') {
      this._router.navigate(['/withdrawpaypal']);
    }
  }
  getInsicStatus() {
    this._ApiService.getInsicStatus().then(res => {
      this._UserHelper.userInsicStatus = parseInt(res);
    });
  }

  confirmButton() {
    const ismobile = this._UiHelper.windowsWidth < 990 ? true : false;

    const withdrawInfo = this._UserHelper.withdrawList.filter(f => f.DepositTypeId == this.WithdrawpaymentType);

    if (withdrawInfo.length > 0) {
      if (this.amount < withdrawInfo[0].MinValue || this.amount > withdrawInfo[0].MaxValue) {
        this.alertMessage = !this.alertMessage;
        const translator = new TranslatePipe(this._LocalizationService);
        const t_message = translator.transform('errorcode9', null);
        const t_message2 = translator.transform('errorcode10', null);
        this.alertMessageDesc = '';

        this.alertMessageDesc =
          t_message +
          ' : ' +
          withdrawInfo[0].MinValue +
          this._UserHelper.customerUser.Symbol +
          ', ' +
          t_message2 +
          ' : ' +
          withdrawInfo[0].MaxValue +
          this._UserHelper.customerUser.Symbol;
        setTimeout(() => {
          this.alertMessage = !this.alertMessage;
        }, 5000);

        //errorcode17,errorcode18
        return;
      } else {
        this._UiHelper.setLoadingDialog(true);
        if (withdrawInfo[0].DepositTypeId === 85) {
          this._ApiService.withdrawPaylado(this.amount, this.WithdrawpaymentType, ismobile).then(result => {
            this._UiHelper.setLoadingDialog(false);
            const translator = new TranslatePipe(this._LocalizationService);

            const apcoresult = JSON.parse(result);

            if (apcoresult.result == 'success') {
              this._UiHelper.successSnackBar(apcoresult.desc, '');
              this._ApiService
                .getClient()
                .then(result => {
                  this._UserHelper.setUser(result);
                })
                .catch();
            } else if (apcoresult.result == 'error') {
              this._UiHelper.errorSnackBar(apcoresult.desc, '');
              const t_message3 = translator.transform('errorcode14', null);
              this.alertMessageDesc = '';
              this.alertMessageDesc = t_message3;
              setTimeout(() => {
                this.alertMessage = !this.alertMessage;
              }, 5000);
            } else if (apcoresult.result == 'errorcode') {
              const t_message = translator.transform(apcoresult.desc, null);
              this._UiHelper.errorSnackBar(t_message, '');
            }
          });
        } else {
          this._ApiService.withdrawOptile(this.amount, this.WithdrawpaymentType, ismobile).then(result => {
            this._UiHelper.setLoadingDialog(false);
            const translator = new TranslatePipe(this._LocalizationService);
            //console.warn("result", result);

            const apcoresult = JSON.parse(result);
            //console.warn("result", apcoresult);

            ////console.warn( apcoresult.result);
            if (apcoresult.result == 'success') {
              ////console.warn(apcoresult.desc);
              //this.firststep = false;
              //this.iframesrc = this.domSanitizer.bypassSecurityTrustResourceUrl(apcoresult.desc);

              const dialogRef = this.dialog.open(DepositFrameDialog, {
                width: '700px',
                height: '70%',
                panelClass: 'transcationDialog',
                data: {
                  depositurl: apcoresult.desc,
                },
              });
              dialogRef.afterClosed().subscribe(result => {
                // //console.log('The dialog was closed',result);
                this._ApiService
                  .getClient()
                  .then(result => {
                    this._UserHelper.setUser(result);
                  })
                  .catch();
              });

              this._UiHelper.setLoadingDialog(true);
            } else if (apcoresult.result == 'error') {
              this._UiHelper.errorSnackBar(apcoresult.desc, '');
              const t_message3 = translator.transform('errorcode14', null);
              this.alertMessageDesc = '';
              this.alertMessageDesc = t_message3;
              setTimeout(() => {
                this.alertMessage = !this.alertMessage;
              }, 5000);
            } else if (apcoresult.result == 'errorcode') {
              const t_message = translator.transform(apcoresult.desc, null);
              this._UiHelper.errorSnackBar(t_message, '');
            }
          });
        }
      }
    } else return;
  }

  goAccountOverView() {
    //Money Transactions sayfasına yönlendirmek için yazıldı
    this._UiHelper.b3000SetAcountMobileState('open', 3);
  }
  getBookings() {
    const tId = environment.IsBet3000 ? -15 : 0;
    this._ApiService.getBookings(this.selectedMonth, this.selectedYear, tId).then(x => {
      this.bookingsList = [];
      this.bookingsList = x.slice(0, 3);

      //////console.log("Bookings List : ", this.bookingsList);
    });
  }
  OpenAccountMobile(selectMenu) {
    this._UiHelper.b3000SetAcountMobileState('open', selectMenu);
    this._UiHelper.b3000SetRightMenuState('close');
  }
}
